import { ThemesProvider } from '../providers/themes-provider.model';

export const themesFactory = (themesProvider: ThemesProvider) => {
  return () => themesProvider.loadTheme();
};
